
import Vue from "vue";
import CatIcon from "@/components/atoms/CatIcon.vue";
import CatNicknameDialogBase from "@/components/ui/CatNicknameDialogBase.vue";
import { AssistantCat } from "@/lib/models/assistantCat";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    CatIcon,
    CatNicknameDialogBase,
  },

  props: {
    assistantCat: {
      type: Object as () => AssistantCat | null,
      default: null,
    },
    initialNickname: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      nickname: this.initialNickname,
    };
  },

  computed: {
    dialogSubtitle(): string {
      const catName = this.assistantCat?.officialName || "";
      return this.$t("myPage.catNicknameDialog.subtitle", { catName }) as string;
    },
  },

  watch: {
    initialNickname(newValue: string) {
      this.nickname = newValue;
    },
  },

  methods: {
    onCancel() {
      this.$emit("cancel");
    },

    onSave() {
      this.$emit("save", this.nickname.trim());
    },

    onClickOutside() {
      this.onCancel();
    },
  },

  mounted() {
    // フォーカスを当てる
    if (this.$refs.nicknameInput) {
      (this.$refs.nicknameInput as HTMLInputElement).focus();
    }
  },
});

interface Data {
  nickname: string;
}

interface Methods {
  onCancel: () => void;
  onSave: () => void;
  onClickOutside: () => void;
}

interface Computed {
  dialogSubtitle: string;
}

interface Props {
  assistantCat: AssistantCat | null;
  initialNickname: string;
}
